import { render, staticRenderFns } from "./HistoryEmptyLink.vue?vue&type=template&id=a71a4710&scoped=true"
import script from "./HistoryEmptyLink.vue?vue&type=script&lang=js"
export * from "./HistoryEmptyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71a4710",
  null
  
)

export default component.exports